// Function to help us with reordering the result
export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const resultList = list.slice();
  const [ removed ] = resultList.splice(startIndex, 1);
  resultList.splice(endIndex, 0, removed);
  return resultList;
}
